export default {
  map: {
    filters: {
      Agent: null,
      Ronde: null,
      date: new Date(),
      formattedDate: null
    },
    agents: [],
    rondes: [],
    searching: false,
    result: null,
    message: null,
    tourneeResults: null,
  },
  login: {
    loading: false,
    message: null,
    loggedIn: false,
    idUser: null
  },
  resetPassword:{
    message: null
  },
  rondes: {
    data: [],
    interventionDetailModal: {
      intervention: null,
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    ajoutInterventionModal: {
      visible: false,
      searching: false,
      searchResults: [],
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    updateModal: {
      visible: false,
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    createModal: {
      visible: false,
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    importModal: {
      visible: false,
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    deleteDebutFinJalonModal: {
      visible: false,
      intervention: null,
      loading: false,
    },
    loadingInterventionsPositions: false,
    interventionsMessage: null,
    message: null,
    searching: false,
  },
  jalons: {
    data: []
  },
  adresses: {
    data: []
  },
  ronde: {
    data: {},
    intervention: null,
    loadingInterventionsPositions: false,
  },
  agents: {
    data: [],
    list: [],
    message: null,
    passwordChangeModal: {
      visible: false,
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    isActiveCreatedAgentModal: false,
  },
  administrators: {
    data: [],
    message: null,
    passwordChangeModal: {
      visible: false,
      loading: false,
      message: null,
      canOnlyExitModal: false,
    },
    isActiveCreatedAdminModal: false,
  },
  anomalies: {
    reporting: [],
    filter: {
      data: [],
    },
    anomalie_image: '',
  },
  showProfilDiv: false,
  reporting: {
    agents: [],
    allAgents: [],
    allRondes: [],
    idAgent: [],
    idRonde: [],
    fromFilterDate: new Date(),
    toFilterDate: new Date(),
    searching: false,
    result: null,
    message: null,
  },
}



// WEBPACK FOOTER //
// ./src/store/state.js